/**
 * The shape of each detail page's skeleton, in one place.
 *
 * A detail view loads in two phases: the route's chunk arrives, then the
 * record's query resolves. Both phases draw `DetailPageSkeleton`, so they
 * should be indistinguishable — but the route was passing the component's
 * defaults while the page passed tuned counts, and the skeleton visibly
 * changed shape halfway through the load. It read as two different skeletons
 * for one view.
 *
 * Routes and pages both spread the same entry from here, so the two phases
 * cannot drift apart again.
 */
export const DETAIL_SKELETON_SHAPES = {
  job: { overviewFields: 5, tableCards: 2, listCards: 2, showProviderCard: true },
  estimate: { overviewFields: 4, tableCards: 2, listCards: 2, showProviderCard: true },
  appointment: { overviewFields: 6, tableCards: 1, listCards: 1, showProviderCard: true },
  invoice: {
    overviewFields: 4,
    tableCards: 2,
    listCards: 1,
    showProviderCard: true,
    showPaymentCard: true,
  },
  // The provider's own page has no provider card — the whole page is that.
  serviceProvider: { overviewFields: 8, tableCards: 0, listCards: 2 },
} as const;
